import React, { Component } from 'react';
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from '@material-ui/core/Tooltip';
import { getColorFromStatusLabel, getIconNameFromStatusLabel, formatStatus } from '../../redux/invoices/invoicesStatusActions'
import '../../statusIcon.css'
import { getCurrentFunctionName } from '../../performanceModeManager';

class InvoiceStatusIcon extends Component {
    render() {
        console.perfLog(getCurrentFunctionName());
        let iconElement;

        iconElement = (
            <Icon className={this.props.className + " status-icon-color-" + getColorFromStatusLabel(this.props.state, this.props.type, this.props.coloredBackground)}>
                {getIconNameFromStatusLabel(this.props.state)}
            </Icon>
        );

        return (
            <Tooltip title={formatStatus(this.props.state)}>
                {iconElement}
            </Tooltip>
        );
    }
}

export default InvoiceStatusIcon;
